<template>
  <div>
    <div class="content">
      <div class="title">1.职位基本信息</div>
      <div class="text">
        职位发布成功后，招聘类型、职位名称、职位类型、工作城市，将无法修改
      </div>
      <div class="box">
        <div class="name">公司:</div>
        <div class="txt">{{ comInfo.trade_cn }} · {{ comInfo.name }}</div>
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span> 联系人:</div>
        <div class="inpBox">
          <input
            class="gkInp"
            v-model="person"
            type="text"
            placeholder="请输入联系人"
          />
          <div class="myBox" @click="nameShowClick">
            <div class="kuang dis-cent" :class="nameShow ? 'on' : ''">
              <div class="iconfont icon-right" v-if="nameShow"></div>
            </div>
            <div class="txt1" :class="nameShow ? 'txtOn' : ''">
              {{ nameShow ? "公开" : "不公开" }}
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span> 联系方式:</div>
        <div class="inpBox">
          <input
            class="gkInp"
            v-model="mobile"
            type="text"
            placeholder="请输入联系方式"
          />
          <div class="myBox" @click="mobileShowClick">
            <div class="kuang dis-cent" :class="mobileShow ? 'on' : ''">
              <div class="iconfont icon-right" v-if="mobileShow"></div>
            </div>
            <div class="txt1" :class="mobileShow ? 'txtOn' : ''">
              {{ mobileShow ? "公开" : "不公开" }}
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span> 职位类型:</div>
        <div
          class="inpBox"
          :class="zwTxt == '请选择职位类型' ? '' : 'on'"
          @click="qwShowJs"
        >
          <div class="seleTxt">{{ zwTxt }}</div>
          <div class="iconfont icon-enter enter"></div>
        </div>
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span> 职位名称:</div>
        <div class="inpBox">
          <input type="text" v-model="jobs_name" placeholder="请输入职位名称" />
        </div>
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span> 职位描述:</div>
        <div class="tareBox">
          <textarea v-model="contents" placeholder="请输入职位描述"></textarea>
        </div>
      </div>
      <div class="title">2.职位要求</div>
      <div class="text">
        我们将通过以下条件，为您精确推荐合适的人才，请尽量详细填写
      </div>
      <div class="box">
        <div class="name mr5">工作性质:</div>
        <a-dropdown>
          <div class="inpBox" :class="nature_cn ? 'on' : ''">
            <div class="seleTxt">
              {{ typeData["工作性质"] ? nature_cn : "请选择工作性质" }}
            </div>
            <div class="iconfont icon-enter enter"></div>
          </div>
          <a-menu
            slot="overlay"
            @click="hyClick"
            :selectedKeys="[typeData['工作性质']]"
          >
            <a-menu-item
              :key="'工作性质_' + item.id + '_' + item.c_name"
              v-for="item in jobs_nature"
              >{{ item.c_name }}</a-menu-item
            >
          </a-menu>
        </a-dropdown>
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span> 办公区域:</div>
        <a-dropdown>
          <div class="inpBox" :class="district_cn ? 'on' : ''">
            <div class="seleTxt">
              {{ district_cn || "请选择办公区域" }}
            </div>
            <div class="iconfont icon-enter enter"></div>
          </div>
          <a-menu
            slot="overlay"
            @click="areaClick"
            :selectedKeys="district.length ? ['办公区域_' + district[0]] : []"
          >
            <a-menu-item
              :key="'办公区域_' + item.id"
              v-for="item in areaList"
            >{{ item.name }}</a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
      <div class="box">
        <div class="name mr5">年龄要求:</div>
        <div class="inpBox">
          <input
            v-model="age"
            type="text"
            placeholder="请输入年龄要求，如24岁-50岁。"
          />
        </div>
      </div>
      <div class="box">
        <div class="name mr5">招聘人数:</div>
        <div class="inpBox">
          <input v-model="amount" type="number" placeholder="请输入招聘人数" />
        </div>
      </div>
      <!-- <div class="box">
        <div class="name mr5">性别要求:</div>
        <a-dropdown>
          <div class="inpBox" :class="sex_cn ? 'on' : ''">
            <div class="seleTxt">
              {{ typeData["性别要求"] ? sex_cn : "请选择性别要求" }}
            </div>
            <div class="iconfont icon-enter enter"></div>
          </div>
          <a-menu
            slot="overlay"
            @click="hyClick"
            :selectedKeys="[typeData['性别要求']]"
          >
            <a-menu-item
              :key="'性别要求_' + item.id + '_' + item.c_name"
              v-for="item in sexList"
              >{{ item.c_name }}</a-menu-item
            >
          </a-menu>
        </a-dropdown>
      </div> -->
      <div class="box">
        <div class="name mr5">经验要求:</div>
        <a-dropdown>
          <div class="inpBox" :class="experience_cn ? 'on' : ''">
            <div class="seleTxt">
              {{ typeData["工作经验要求"] ? experience_cn : "请选择经验要求" }}
            </div>
            <div class="iconfont icon-enter enter"></div>
          </div>
          <a-menu
            slot="overlay"
            @click="hyClick"
            :selectedKeys="[typeData['工作经验要求']]"
          >
            <a-menu-item
              :key="'工作经验要求_' + item.id + '_' + item.c_name"
              v-for="item in experience"
              >{{ item.c_name }}</a-menu-item
            >
          </a-menu>
        </a-dropdown>
      </div>
      <div class="box">
        <div class="name mr5">学历要求:</div>
        <a-dropdown>
          <div class="inpBox" :class="education_cn ? 'on' : ''">
            <div class="seleTxt">
              {{ typeData["学历要求"] ? education_cn : "请选择学历" }}
            </div>
            <div class="iconfont icon-enter enter"></div>
          </div>
          <a-menu
            slot="overlay"
            @click="hyClick"
            :selectedKeys="[typeData['学历要求']]"
          >
            <a-menu-item
              :key="'学历要求_' + item.id + '_' + item.c_name"
              v-for="item in education"
              >{{ item.c_name }}</a-menu-item
            >
          </a-menu>
        </a-dropdown>
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span> 薪资范围:</div>
        <div class="selectBoxs">
          <div class="selectBox">
            <div
              class="myBox"
              @click="myShowClick(index)"
              v-for="(item, index) in xzTypeList"
            >
              <div
                class="kuang dis-cent"
                :class="index == xzTypeOn ? 'on' : ''"
              >
                <div class="iconfont icon-right" v-if="index == xzTypeOn"></div>
              </div>
              <div class="txt1" :class="myShow ? 'txtOn' : ''">
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="moneySelectBox" v-if="xzTypeOn == 0">
            <div class="mTitle">定额薪资</div>
            <div class="conts">
              <a-select
                show-search
                placeholder="月薪"
                option-filter-prop="children"
                style="width: 120px; height: 35px"
                v-model="qValue"
                :filter-option="filterOption"
                @change="handleChange"
              >
                <a-select-option
                  :value="item.name"
                  v-for="item in qMoney"
                  :key="item.name"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <div class="jian dis-cent">-</div>
              <a-select
                show-search
                placeholder="月薪"
                option-filter-prop="children"
                style="width: 120px; height: 35px"
                v-model="hValue"
                :filter-option="filterOption"
                @change="hhandleChange"
              >
                <a-select-option v-for="item in hMoney" :key="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <div class="cha dis-cent">x</div>
              <a-select
                show-search
                placeholder="月数"
                option-filter-prop="children"
                style="width: 120px; height: 35px"
                v-model="mothMoneyOn"
                :filter-option="filterOption"
                @change="mothHandleChange"
              >
                <a-select-option
                  :value="item.name"
                  v-for="item in yMoney"
                  :key="item.id"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div class="moneySelectBox" v-if="xzTypeOn == 1">
            <div class="mTitle">底薪</div>
            <div class="conts">
              <a-select
                show-search
                placeholder="月薪"
                option-filter-prop="children"
                style="width: 120px; height: 35px"
                v-model="dxMinNum"
                :filter-option="filterOption"
                @change="dxMinChange"
              >
                <a-select-option v-for="item in dxMinList" :key="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <div class="jian dis-cent">-</div>
              <a-select
                show-search
                placeholder="月薪"
                option-filter-prop="children"
                style="width: 120px; height: 35px"
                v-model="dxMaxNum"
                :filter-option="filterOption"
                @change="dxMaxChange"
              >
                <a-select-option v-for="item in dxMaxList" :key="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
            <div class="mTitle">平均收入(底薪+提成)</div>
            <div class="conts">
              <a-select
                show-search
                placeholder="月薪"
                option-filter-prop="children"
                style="width: 120px; height: 35px"
                v-model="pjMinNum"
                :filter-option="filterOption"
                @change="pjMinChange"
              >
                <a-select-option v-for="item in pjMinList" :key="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <div class="jian dis-cent">-</div>
              <a-select
                show-search
                placeholder="月薪"
                option-filter-prop="children"
                style="width: 120px; height: 35px"
                v-model="pjMaxNum"
                :filter-option="filterOption"
                @change="pjMaxChange"
              >
                <a-select-option v-for="item in pjMaxList" :key="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
            <div class="txt">注：真实的薪资更利于提高招聘效果</div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="name mr5">职位福利:</div>
        <div class="zwCont">
          <div class="zwBox dis-cent" v-for="(item, index) in zwldList">
            <div class="zwtxt">{{ item }}</div>
            <div
              class="iconfont icon-close close"
              @click="zwDelClick(index)"
            ></div>
          </div>
          <div
            class="iconfont icon-add addBox dis-cent"
            @click="ldShow = true"
          ></div>
        </div>
      </div>
      <!-- <div class="box">
        <div class="name">期望人才:</div>
        <div class="zwCont">
          <div
            class="iconfont icon-add addBox dis-cent"
            @click="peoShow = true"
          ></div>
          <div class="zwBox dis-cent" v-for="(item, index) in zwldList">
            <div class="zwtxt">{{ item }}</div>
            <div
              class="iconfont icon-close close"
              @click="zwDelClick(index)"
            ></div>
          </div>
        </div>
      </div> -->
      <div class="box">
        <div class="name mr5">是否加急:</div>
        <div class="selectBoxs">
          <div class="selectBox">
            <div class="myBox" @click="jpShowClick">
              <div class="kuang dis-cent" :class="jpShow ? 'on' : ''">
                <div class="iconfont icon-right" v-if="jpShow"></div>
              </div>
              <div class="txt1" :class="jpShow ? 'txtOn' : ''">
                急聘
                <span style="color: red; margin-left: 15px"
                  >(可用{{ vipInfo.worry_time }}小时)</span
                >
              </div>
            </div>
          </div>
          <div class="jiajiSelectBox" v-if="jpShow">
            <div
              class="numBox dis-cent"
              :class="item.id == timeOn ? 'on' : ''"
              v-for="item in timeList"
              @click="timeClick(item.id)"
            >
              {{ item.name }}
            </div>
            <div
              class="numCont"
              @click="timeClick(100)"
              :class="100 == timeOn ? 'on' : ''"
            >
              <div class="inp">
                <input type="number" placeholder="自定义" v-model="jjTime" />
              </div>
              <div class="txt">小时</div>
            </div>
          </div>
          <div class="bzTxt" v-if="jptime > 0">
            注：该项目急聘到期时间还有{{ jptime }}小时
          </div>
        </div>
      </div>
      <div class="box">
        <div class="name mr5">工作地址:</div>
        <div class="inpBox">
          <input
            v-model="job_address"
            type="text"
            placeholder="请输入年龄要求，如24岁-50岁。"
          />
        </div>
      </div>
      <div class="fbBox">
        <div class="btn dis-cent" @click="saveClick">发布</div>
      </div>
    </div>
    <XuanzeLb v-if="qwShow" :num="1" @show="qwShowDelJs" :qwData="qwData" />
    <LdSave v-if="ldShow" @show="ldShowDelJs" />
    <PeoSave v-if="peoShow" @show="peoShowDelJs" />
  </div>
</template>

<script>
import XuanzeLb from "../../component/xuanzeLb.vue";
import {
  Select,
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
} from "ant-design-vue";
import LdSave from "./ldSave.vue";
import PeoSave from "./peoSave.vue";
export default {
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    XuanzeLb,
    LdSave,
    PeoSave,
  },
  name: "",
  data() {
    return {
      jobtag: [],
      peoShow: false,
      ldShow: false,
      qwData: [],
      qwShow: false,
      typeData: {
        工作性质: "",
        学历要求: "",
        工作经验要求: "",
        性别要求: "",
      },
      jobs_nature: [],
      education: [],
      experience: [],
      qMoneyOn: null,
      qValue: undefined,
      qMoney: [],
      hValue: undefined,
      hMoney: [],
      mothMoneyOn: undefined,
      yMoney: [],
      myShow: false,
      zwTxt: "请选择职位类型",
      zwid: "",
      nameShow: true,
      mobileShow: true,
      comInfo: {},
      sex_id: "",
      sex_cn: "",
      sexList: [
        {
          id: "0",
          c_name: "不限",
        },
        {
          id: "1",
          c_name: "男",
        },
        {
          id: "2",
          c_name: "女",
        },
      ],
      person: "",
      mobile: "",
      education_id: "",
      education_cn: "",
      experience_id: "",
      experience_cn: "",
      nature_id: "",
      nature_cn: "",
      age: "",
      jobs_name: "",
      amount: "",
      minwage: "",
      maxwage: "",
      contents: "",
      pricemonth: "",
      jpShow: false,
      zwldList: [],
      xzTypeOn: null,
      xzTypeList: [
        {
          name: "定额薪资",
        },
        {
          name: "底薪+提成",
        },
        {
          name: "面议",
        },
      ],
      dxMinNum: undefined,
      dxMinList: [],
      dxMaxNum: undefined,
      dxMaxList: [],
      pjMinNum: undefined,
      pjMinList: [],
      pjMaxNum: undefined,
      pjMaxList: [],
      timeOn: null,
      timeList: [
        {
          id: 2,
          name: "2小时",
        },
        {
          id: 5,
          name: "5小时",
        },
        {
          id: 8,
          name: "8小时",
        },
      ],
      jjTime: "",
      jptime: 0,
      vipInfo: {},
      job_address: "",
      areaList: [
        { id: 3723, pid: 1146, name: "玉城" },
        { id: 3724, pid: 1146, name: "坎门" },
        { id: 3725, pid: 1146, name: "大麦屿" },
        { id: 3726, pid: 1146, name: "楚门" },
        { id: 3727, pid: 1146, name: "清港" },
        { id: 3728, pid: 1146, name: "龙溪" },
        { id: 3729, pid: 1146, name: "芦浦" },
        { id: 3730, pid: 1146, name: "沙门" },
        { id: 3731, pid: 1146, name: "干江" },
        { id: 3732, pid: 1146, name: "鸡山" },
        { id: 3733, pid: 1146, name: "海山" },
      ],
      district: [],
      district_cn: "",
      // 保存 district_options 原始完整路径数据，提交时用
      districtOptions: [],
    };
  },
  props: ["id", "kaifang"],
  created() {
    for (let i = 0; i < 100; i++) {
      this.qMoney.push({
        name: i + 1 + "K",
        id: i + 1,
      });
    }
    for (let i = 12; i < 30; i++) {
      this.yMoney.push({
        name: i + "月",
        id: i,
      });
    }
    this.typeGet();
    this.get();
    if (this.id) {
      this.bjget();
    }
    this.dxMkGet();
  },
  methods: {
    dxMkGet() {
      for (let i = 0; i < 100; i++) {
        this.dxMinList.push({
          name: i + 1 + "K",
          id: i + 1,
        });
      }
      for (let i = 0; i < 100; i++) {
        this.pjMinList.push({
          name: i + 1 + "K",
          id: i + 1,
        });
      }
    },
    dxMinChange(value) {
      console.log(value);
      let on;
      for (let i = 0; i < this.dxMinList.length; i++) {
        const e = this.dxMinList[i];
        if (e.id == value) {
          on = i;
        }
      }
      console.log(on);
      this.dxMinNum = value;
      const newArray = this.removeElementsBeforeIndex(
        this.dxMinList.slice(),
        on + 1
      );
      this.dxMaxList = newArray;
      console.log(this.dxMaxList);
    },
    dxMaxChange(value) {
      this.dxMaxNum = value;
    },
    pjMinChange(value) {
      let on;
      for (let i = 0; i < this.pjMinList.length; i++) {
        const e = this.pjMinList[i];
        if (e.id == value) {
          on = i;
        }
      }
      this.pjMinNum = value;
      const newArray = this.removeElementsBeforeIndex(
        this.pjMinList.slice(),
        on + 1
      );
      this.pjMaxList = newArray;
    },
    pjMaxChange(value) {
      this.pjMaxNum = value;
    },
    timeClick(id) {
      this.timeOn = id;
    },
    ldShowDelJs(data) {
      console.log(data);
      this.ldShow = false;
      if (data) {
        this.zwldList.push(data);
      }
    },
    peoShowDelJs(data) {
      console.log(data);
      this.peoShow = false;
      // if (data) {
      //   this.zwldList.push(data);
      // }
    },
    zwDelClick(i) {
      this.zwldList.splice(i, 1);
    },
    bjget() {
      let url;
      if (this.kaifang == 1) {
        url = "/nozzle/web/job_update_info";
      }
      if (this.kaifang == 2) {
        url = "/nozzle/web/job_tmp_update_info";
      }
      this.$get(url, {
        id: this.id,
      }).then((res) => {
        console.log(res.data);
        let data = res.data;
        this.data = data;
        this.mobile = data.mobile;
        this.person = data.person;
        this.nameShow = data.is_person == 1 ? true : false;
        this.mobileShow = data.is_mobile == 1 ? true : false;
        let keys = [data.topclass, data.category, data.subclass];
        this.qwData = [
          {
            id: data.category,
            categoryname: data.category_cn,
            zTxt: data.category_cn,
            key: keys.join(","),
          },
        ];
        this.zwid = keys.join(",");
        this.zwTxt = data.category_cn;
        this.jobs_name = data.jobs_name;
        this.contents = data.contents;
        this.nature_cn = data.nature_cn;
        // 工作性质
        this.nature_id = data.nature;
        this.typeData["工作性质"] =
          "工作性质_" + data.nature + "_" + data.nature_cn;
        this.age = data.age;
        this.amount = data.amount;
        // 工作经验
        this.sex_cn = data.sex_cn;
        this.sex_id = data.sex;
        this.typeData["性别要求"] = "性别要求_" + data.sex + "_" + data.sex_cn;
        // 工作经验要求
        this.experience_cn = data.experience_cn;
        this.experience_id = data.experience;
        this.typeData["工作经验要求"] =
          "工作经验要求_" + data.experience + "_" + data.experience_cn;
        // 工作经验要求
        this.education_cn = data.education_cn;
        this.education_id = data.education;
        this.typeData["学历要求"] =
          "学历要求_" + data.education + "_" + data.education_cn;
        if (data.minwage != 0 && data.maxwage != 0) {
          this.xzTypeOn = data.wagetype == 1 ? 0 : data.wagetype == 2 ? 1 : 2;
          if (this.xzTypeOn == 0) {
            this.qValue = data.minwage + "K";
            this.hValue = data.maxwage + "K";
            this.mothMoneyOn = data.pricemonth + "月";
            this.qMoneyOn = data.minwage;
            this.hMoneyOn = data.maxwage;
            const newArray = this.removeElementsBeforeIndex(
              this.qMoney.slice(),
              data.minwage
            );
            this.hMoney = newArray;
          } else if (this.xzTypeOn == 1) {
            const newArray = this.removeElementsBeforeIndex(
              this.dxMinList.slice(),
              data.minsalary
            );
            this.dxMaxList = newArray;
            const newArray1 = this.removeElementsBeforeIndex(
              this.pjMinList.slice(),
              data.minwage
            );
            this.pjMaxList = newArray1;
            this.dxMinNum = data.minsalary;
            this.dxMaxNum = data.maxsalary;
            this.pjMinNum = data.minwage;
            this.pjMaxNum = data.maxwage;
            this.mothMoneyOn = data.pricemonth;
          }
          this.$forceUpdate();
        } else {
          this.xzTypeOn = 2;
          // this.myShow = true;
        }
        if (data.tag_cn) {
          this.zwldList = data.tag_cn.split(",");
        } else {
          this.zwldGet();
        }
        if (data.job_address) {
          this.job_address = data.job_address;
        } else {
          this.dzGet();
        }
        // this.jpShow = data.is_worry == 1 ? true : false;
        this.jptime = this.timeXcGet(data.worry_end_time);
        // 办公区域回显（单选）
        if (data.district) {
          // 取第一个路径的末端 id（兼容历史多选数据，只取第一个）
          let firstPath = data.district.split("|")[0];
          let parts = firstPath.split(",");
          this.district = [Number(parts[parts.length - 1])];
        }
        if (data.district_cn) {
          // 取第一个区域的纯名称
          let firstName = data.district_cn.split("|")[0];
          this.district_cn = firstName.replace("台州/玉环/", "");
        }
      });
    },
    timeXcGet(time) {
      const now = this.$moment();
      let jptime = this.$moment(time * 1000).format();
      jptime = this.$moment(jptime);
      jptime = this.$moment.duration(jptime.diff(now));
      return jptime.asHours().toFixed(1);
    },
    saveClick() {
      let info = {
        ...this.data,
      };
      if (!this.person) {
        this.$message.error("请填写联系人");
        return;
      }
      info.person = this.person;
      info.is_person = this.nameShow ? 1 : 2;
      if (!this.mobile) {
        this.$message.error("请填写联系方式");
        return;
      }
      info.mobile = this.mobile;
      info.is_mobile = this.mobileShow ? 1 : 2;
      if (!this.zwid) {
        this.$message.error("请选择职位类型");
        return;
      }
      let zwid = this.zwid.split(",");
      if (zwid[0]) {
        info.topclass = Number(zwid[0]);
      }
      if (zwid[1]) {
        info.topclass = Number(zwid[0]);
        info.category = Number(zwid[1]);
      }
      if (zwid[2]) {
        info.topclass = Number(zwid[0]);
        info.category = Number(zwid[1]);
        info.subclass = Number(zwid[2]);
      }
      console.log(info);
      info.category_cn = this.zwTxt;
      if (!this.jobs_name) {
        this.$message.error("请输入职位名称");
        return;
      }
      info.jobs_name = this.jobs_name;
      if (!this.contents) {
        this.$message.error("请输入职位描述");
        return;
      }
      info.contents = this.contents;
      // if (!this.nature_id) {
      //   this.$message.error("请选择工作性质");
      //   return;
      // }
      info.nature = Number(this.nature_id);
      info.nature_cn = this.nature_cn;
      info.age = this.age;
      // if (!this.amount) {
      //   this.$message.error("请输入招聘人数");
      //   return;
      // }
      info.amount = Number(this.amount);
      // if (!this.sex_id && this.sex_cn != "不限") {
      //   this.$message.error("请选择性别要求");
      //   return;
      // }
      info.sex = Number(this.sex_id);
      info.sex_cn = this.sex_cn;
      // if (!this.experience_id) {
      //   this.$message.error("请选择经验要求");
      //   return;
      // }
      info.experience = Number(this.experience_id);
      info.experience_cn = this.experience_cn;
      // if (!this.education_id) {
      //   this.$message.error("请选择学历");
      //   return;
      // }
      info.education = Number(this.education_id);
      info.education_cn = this.education_cn;
      if (this.xzTypeOn == null) {
        this.$message.error("请选择薪资范围");
        return;
      }
      if (this.xzTypeOn == 0) {
        if (!this.qMoneyOn) {
          this.$message.error("最低薪资");
          return;
        }
        if (!this.hMoneyOn) {
          this.$message.error("最高薪资");
          return;
        }
        if (!this.mothMoneyOn) {
          this.$message.error("月薪数");
          return;
        }
        info.minwage = Number(this.qMoneyOn);
        info.maxwage = Number(this.hMoneyOn);
        info.pricemonth = Number(this.mothMoneyOn);
        info.minsalary = 0;
        info.maxsalary = 0;
        info.wagetype = 1;
      } else if (this.xzTypeOn == 1) {
        if (!this.dxMinNum) {
          this.$message.error("最低薪资");
          return;
        }
        if (!this.dxMaxNum) {
          this.$message.error("最高薪资");
          return;
        }
        if (!this.pjMinNum) {
          this.$message.error("最低薪资");
          return;
        }
        if (!this.pjMaxNum) {
          this.$message.error("最高薪资");
          return;
        }
        info.minsalary = Number(this.dxMinNum);
        info.maxsalary = Number(this.dxMaxNum);
        info.minwage = Number(this.pjMinNum);
        info.maxwage = Number(this.pjMaxNum);
        info.pricemonth = 0;
        info.wagetype = 2;
      } else if (this.xzTypeOn == 2) {
        info.minsalary = 0;
        info.maxsalary = 0;
        info.minwage = 0;
        info.maxwage = 0;
        info.pricemonth = 0;
        info.wagetype = 3;
      }
      if (this.jpShow) {
        if (this.timeOn == 100) {
          info.worry_time = Number(this.jjTime);
          if (!info.worry_time) {
            this.$message.error("请填写急聘时间");
            return;
          }
        } else {
          info.worry_time = this.timeOn;
          if (!info.worry_time) {
            this.$message.error("请填写急聘时间");
            return;
          }
        }
      } else {
        info.worry_time = 0;
      }
      info.is_worry = this.jpShow ? 1 : 0;
      if (this.zwldList.length != 0) {
        info.tag_cn = this.zwldList.join(",");
      }
      info.job_address = this.job_address;
     // 办公区域（单选）：根据选中 id 从 districtOptions 取完整路径
      if (this.district.length > 0 && this.districtOptions.length > 0) {
        const id = this.district[0];
        const opt = this.districtOptions.find(o => {
          const parts = o.district.split(",");
          return Number(parts[parts.length - 1]) === id;
        });
        if (opt) {
          info.district = opt.district;
          info.district_cn = opt.district_cn;
        } else {
          info.district = "";
          info.district_cn = "";
        }
      } else if (this.district.length > 0) {
        // 公司没设办公区域，用静态 areaList 拼完整路径
        const id = this.district[0];
        const item = this.areaList.find(a => a.id === id);
        if (item) {
          info.district = "1142,1146," + id;
          info.district_cn = "台州/玉环/" + item.name;
        } else {
          info.district = "";
          info.district_cn = "";
        }
      } else {
        info.district = "";
        info.district_cn = "";
      }

      console.log(info);
      info = JSON.stringify(info);
      let url;
      if (this.kaifang == 1) {
        url = "/nozzle/web/job_save";
      }
      if (this.kaifang == 2) {
        url = "/nozzle/web/job_tmp_save";
      }
      this.$post(url, {
        data: info,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$router.back();
          this.$message.success("发布成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    zwldGet() {
      this.$get("/nozzle/web/company_info").then((res) => {
        console.log(res);
        this.zwldList = res.data.welfare.split(",");
      });
    },
    dzGet() {
      this.$get("/nozzle/web/company_info").then((res) => {
        this.job_address = res.data.address;
      });
    },
    get() {

      this.$get("/nozzle/web/company_info").then((res) => {
        console.log(res);
        this.comInfo = res.data;
        this.vipInfo = res.vip;
        // 从公司信息动态构建办公区域列表
        if (res.data.district_options && res.data.district_options.length) {
          // 保存原始完整路径数据，提交时用
          this.districtOptions = res.data.district_options;
          this.areaList = res.data.district_options.map(opt => {
            const parts = opt.district.split(",");
            const nameParts = opt.district_cn.split("/");
            return {
              id: Number(parts[parts.length - 1]),
              pid: Number(parts[parts.length - 2]) || 1146,
              name: nameParts[nameParts.length - 1]
            };
          });
        }
        if (!this.id) {
          this.zwldList = res.data.welfare.split(",");
          this.job_address = res.data.address;
          this.person = res.data.person;
          this.mobile = res.data.mobile;
        }
        // 新建岗位时，办公区域默认选中第一个
        if (!this.id && this.areaList.length && this.district.length === 0) {
          this.district = [this.areaList[0].id];
          this.district_cn = this.areaList[0].name;
        }
      });
    },
    jpShowClick() {
      this.jpShow = !this.jpShow;
    },
    nameShowClick() {
      this.nameShow = !this.nameShow;
    },
    mobileShowClick() {
      this.mobileShow = !this.mobileShow;
    },
    qwShowJs() {
      this.qwShow = true;
    },
    qwShowDelJs(data) {
      console.log(data);
      if (data) {
        if (data.data.length != 0) {
          this.qwData = data.data;
          this.zwid = data.data[0].key;
          this.zwTxt = data.data[0].zTxt;
        }
      }
      this.qwShow = false;
    },
    myShowClick(i) {
      this.xzTypeOn = i;
      // this.myShow = !this.myShow;
    },
    handleChange(value) {
      let on;
      for (let i = 0; i < this.qMoney.length; i++) {
        const e = this.qMoney[i];
        if (e.name == value) {
          on = i;
        }
      }
      this.qMoneyOn = on + 1;
      const newArray = this.removeElementsBeforeIndex(
        this.qMoney.slice(),
        on + 1
      );
      this.hMoney = newArray;
    },
    removeElementsBeforeIndex(arr, index) {
      if (index > 0) {
        arr.splice(0, index);
      } else if (index < 0) {
        throw new Error("Index out of range");
      }
      return arr;
    },
    hhandleChange(value) {
      console.log(value);
      this.hMoneyOn = value;
    },
    mothHandleChange(value) {
      console.log(value);
      this.mothMoneyOn = value.split("月")[0];
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    hyClick(e) {
      let key = e.key.split("_");
      this.typeData[key[0]] = e.key;
      console.log(key);
      if (key[0] == "工作性质") {
        this.nature_cn = key[2];
        this.nature_id = key[1];
      }
      if (key[0] == "学历要求") {
        this.education_cn = key[2];
        this.education_id = key[1];
      }
      if (key[0] == "工作经验要求") {
        this.experience_cn = key[2];
        this.experience_id = key[1];
      }
      if (key[0] == "性别要求") {
        this.sex_cn = key[2];
        this.sex_id = key[1];
      }
    },
    typeGet() {
      this.$get("/common/category_gets", {
        pageNo: -1,
      }).then((res) => {
        // 职位亮点
        let jobtag = [];
        // 工作性质
        let jobs_nature = [];
        // 学历
        let education = [];
        // 工作经验要求
        let experience = [];
        for (let i = 0; i < res.data.length; i++) {
          const e = res.data[i];
          e.select = false;
          if (e.c_alias == "QS_jobtag") {
            jobtag.push(e);
          }
          if (e.c_alias == "QS_jobs_nature") {
            jobs_nature.push(e);
          }
          if (e.c_alias == "QS_education") {
            education.push(e);
          }
          if (e.c_alias == "QS_experience") {
            experience.push(e);
          }
        }
        this.jobtag = jobtag;
        this.jobs_nature = jobs_nature;
        this.education = education;
        this.experience = experience;
      });
    },
    ldShowJs(e) {
      console.log(e);

      this.ldData = e.data;
      this.ldShow = false;
    },
    areaClick(e) {
      // 单选：key 格式为 "办公区域_id"
      let key = e.key.split("_");
      let id = Number(key[1]);
      this.district = [id];
      let item = this.areaList.find(a => a.id === id);
      this.district_cn = item ? item.name : "";
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  .title {
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 5px;
  }
  .text {
    color: #666;
    margin-bottom: 30px;
  }
  .box {
    display: flex;
    margin-bottom: 15px;
    .name {
      color: #666;
      width: 90px;
      text-align: right;
    }
    .mr5 {
      margin-top: 5px;
    }
    .txt {
      width: calc(100% - 90px);
      padding-left: 10px;
      box-sizing: border-box;
      font-size: 14px;
    }
    .inpBox {
      width: 500px;
      padding: 0 10px;
      height: 35px;
      margin-left: 10px;
      border-radius: 5px;
      box-sizing: border-box;
      border: 1px solid #ebebeb;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #9c9c9c;
      overflow: hidden;
      cursor: pointer;
      .seleTxt {
        width: calc(100% - 35px);
      }
      .enter {
        width: 35px;
        text-align: right;
        font-size: 14px;
      }
      input {
        width: 100%;
        height: 100%;
        color: #000;
      }
      .gkInp {
        width: calc(100% - 80px);
      }
    }
    .on {
      color: #333;
    }
    .selectBoxs {
      width: 500px;
      box-sizing: border-box;
      margin-left: 10px;
      .selectBox {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }
      .selectBox:last-child {
        margin-bottom: 0;
      }

      .bzTxt {
        color: #ec0c0c;
      }
      .moneySelectBox {
        padding: 10px 15px;
        border-radius: 10px;
        background-color: #f0f8ff;
        .mTitle {
          margin-bottom: 10px;
          margin-top: 10px;
        }
        .mTitle:first-child {
          margin-top: 0;
        }
        .conts {
          display: flex;
          align-items: center;
        }
        .txt {
          color: #888;
          font-size: 12px;
          margin-top: 10px;
        }
      }
      .jiajiSelectBox {
        padding: 10px 15px;
        border-radius: 10px;
        background-color: #f0f8ff;
        display: flex;
        align-items: center;
        .numBox {
          height: 40px;
          border-radius: 10px;
          border: 1px solid #ebebeb;
          background-color: #fff;
          width: 90px;
          margin-right: 10px;
          cursor: pointer;
        }
        .numCont {
          height: 40px;
          border-radius: 10px;
          border: 1px solid #ebebeb;
          background-color: #fff;
          width: 110px;
          cursor: pointer;
          display: flex;
          align-items: center;
          .inp {
            width: calc(100% - 43px);
            box-sizing: border-box;
            padding-left: 10px;
            input {
              width: 100%;
            }
          }
          .txt {
            width: 43px;
            box-sizing: border-box;
            padding-right: 10px;
            padding-left: 0;
            text-align: right;
          }
        }
        .on {
          border: 1px solid #147ee0;
        }
      }
      .cont {
        width: calc(33.33% - 10px);
        height: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #ebebeb;
        border-radius: 5px;
        padding: 0 10px;
        color: #9c9c9c;
        cursor: pointer;
        .seleTxt {
          width: calc(100% - 35px);
        }
        .enter {
          width: 35px;
          text-align: right;
          font-size: 14px;
        }
      }
      .cont:last-child {
        margin-right: 0;
      }
      .gang {
        width: 10px;
      }
      .jian {
        width: 30px;
        height: 35px;
        font-size: 26px;
        position: relative;
        top: -4px;
      }
      .cha {
        width: 30px;
        font-size: 16px;
        position: relative;
        top: -4px;
      }
    }
    .myBox {
      display: flex;
      align-items: center;
      // justify-content: center;
      // width: 80px;
      cursor: pointer;
      margin-right: 15px;
      padding-top: 5px;
      .kuang {
        width: 18px;
        height: 18px;
        border-radius: 5px;
        border: 1px solid #c9c9c9;
      }
      .on {
        border: 1px solid #147ee0;
        background-color: #147ee0;
        color: #fff;
      }
      .txt1 {
        font-size: 14px;
        margin-left: 6px;
        color: #666;
        white-space: nowrap;
      }
      .txtOn {
        color: #147ee0;
      }
    }
    .selectYearBoxs {
      width: 500px;
      height: 35px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      margin-left: 10px;
      .cont {
        width: calc(50% - 7.5px);
        margin-right: 15px;
        height: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #ebebeb;
        border-radius: 5px;
        padding: 0 10px;
        color: #9c9c9c;
        cursor: pointer;
        .seleTxt {
          width: calc(100% - 35px);
        }
        .enter {
          width: 35px;
          text-align: right;
          font-size: 14px;
        }
      }
      .cont:last-child {
        margin-right: 0;
      }
    }
    .zwCont {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 500px;
      padding: 0 10px;
      // height: 35px;
      margin-left: 10px;
      .addBox {
        width: 70px;
        height: 30px;
        border-radius: 30px;
        border: 1px solid #ebebeb;
        box-sizing: border-box;
        color: #9c9c9c;
        margin-right: 10px;
        cursor: pointer;
        margin-bottom: 10px;
      }
      .zwBox {
        height: 30px;
        background-color: #e9effa;
        padding: 0 15px 0 20px;
        border-radius: 30px;
        margin-right: 10px;
        margin-bottom: 10px;
        .close {
          font-size: 12px;
          font-weight: 600;
          position: relative;
          top: 1px;
          margin-left: 7px;
          cursor: pointer;
        }
      }
    }
    .tareBox {
      height: 160px;
      width: 500px;
      margin-left: 10px;
      border-radius: 5px;
      box-sizing: border-box;
      border: 1px solid #ebebeb;
      display: flex;
      align-items: center;
      justify-content: space-between;
      overflow: hidden;
      cursor: pointer;
      textarea {
        width: 100%;
        height: 100%;
        border: none;
        padding: 10px;
      }
    }
  }
  .fbBox {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 30px;
    .btn {
      width: 90px;
      height: 40px;
      border-radius: 5px;
      background-color: #147ee0;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
